import { render, staticRenderFns } from "./subscriptionsComponent.vue?vue&type=template&id=249b4529&scoped=true&"
import script from "./subscriptionsComponent.vue?vue&type=script&lang=js&"
export * from "./subscriptionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b4529",
  null
  
)

export default component.exports